import { getUsers } from '@signiapp/core/services/access';
export default {
  getUsers: getUsers
};